export default __webpack_public_path__ + "static/dapster-88555c2a675ca9cbb59ae70ff5611e58.png";